import { combineReducers } from 'redux'
import allWorkflows from './allWorkflows'
import tenantWorkflows from './tenantWorkflows'

export default combineReducers({
  allWorkflows,
  tenantWorkflows,
})
